import { requestType } from "~/config/enum.config";
var SERVICE = "domain-service";
var CONTROLLER = "systemToolController";
/**
 * 系统工具
 */
export default {
    /**
     * 获取风险信息合计数据
     */
    queryRiskInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: "queryRiskInfo",
        type: requestType.Get
    },
    /**
     * 分页查询单个风险项
     * @param data
     * @returns
     */
    queryRiskFxContent: {
        service: SERVICE,
        controller: CONTROLLER,
        action: "queryRiskFxContent",
        type: requestType.Get
    },
    /**
     * 法院信息查询混合
     * @param data
     * @returns
     */
    queryRiskInfoMixed: {
        service: SERVICE,
        controller: CONTROLLER,
        action: "queryRiskInfoMixed",
        type: requestType.Get
    },
    /**
     * 下载法院信息查询模板
     * @param data
     * @returns
     */
    downLoadRiskInfoTemplate: {
        service: SERVICE,
        controller: CONTROLLER,
        action: "downLoadRiskInfoTemplate",
        type: requestType.Get
    },
    /**
     * excel导入法院信息查询导出
     * @param data
     * @returns
     */
    downloadRiskInfo: {
        service: SERVICE,
        controller: CONTROLLER,
        action: "downloadRiskInfo",
        type: requestType.Get
    }
};
